import PropTypes from "prop-types";
import React, { Component } from "react";
import "./Toggle.css";
import {getCanDataReport} from '../../Layouts/config/reports/canDataReport'

export default class SnapToggle extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    window.snaplive = this.props.selected
    window.renderCanTable = true
    const { selected, toggleSelected } = this.props;
    return (
      <div className="toggle-main">
        <div className="rawtext">Live Data</div>
      <div className="toggle-container" onClick={toggleSelected}>
        <div className={`dialog-button ${selected ? "" : "disabled"}`}>
          {selected ? "" : ""}
        </div>
      </div>
      </div>
    );
  }
}

